export default "__VITE_ASSET__CmLzEDCG__"